/** Ticket #939 — CTA « autre créneau même service » dans le bandeau panier. */

export const CART_ADD_ANOTHER_SLOT_TEST_ID = 'cart-add-another-slot-same-service';

export function shouldOfferAnotherSlotSameService(itemCount: number): boolean {
  return itemCount > 0;
}
